import React from 'react';
import { useParams } from 'react-router-dom';
import { TransactionViewer } from '../../components/viewer';

export default function CashSaleViewer() {
  const { id } = useParams();

  return <TransactionViewer transactionId={id} transactionType="cash_sale" />;
}
